'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPlaylistAddCheck = function MdPlaylistAddCheck(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.9 19.1l2.5 2.5-11.7 11.8-7.6-7.5 2.5-2.5 5.1 5z m-32.5 7.5v-3.2h13.2v3.2h-13.2z m20-16.6v3.4h-20v-3.4h20z m0 6.6v3.4h-20v-3.4h20z' })
        )
    );
};

exports.default = MdPlaylistAddCheck;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/playlist-add-check.js
// module id = 1857
// module chunks = 168707334958949